import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import PermissionDenied from 'src/pages/dashboard/PermissionDenied';

type AclBasedGuardProps = {
  children: React.ReactNode;
  acls: string[];
};

export function AclBasedGuard({ children, acls }: AclBasedGuardProps) {
  if (checkAclValidation({ acls })) {
    return <>{children}</>;
  }
  return <PermissionDenied />;
}
